'use strict';

var base = require('base/components/menu');

function mobileMenu() {
    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };
    
    $('.dropdown:not(.disabled) [data-toggle="dropdown"]').on('click', function (e) {
        if (!isDesktop(this)) {
            $(this).parent().children('.dropdown-menu').find('.nav-menu:first-child').detach();
            $(this).parents('.nav.navbar-nav').addClass('nav-selected');
            $(this).parents('.nav.navbar-nav').find('.nav-item.dropdown').removeClass('show');
            $(this).parent().addClass('show');
            if ($(this).parents('.nav.navbar-nav').find('.nav-item.dropdown.show .dropdown-menu').children('.top-category').length > 1) {
                $(this).parents('.nav.navbar-nav').find('.nav-item.dropdown.show .dropdown-menu').children('.top-category:first-child').detach();
            }
            $('.nav.navbar-nav').find('.nav-item.dropdown:not(.show) .dropdown-menu').children('.top-category').detach();
            e.preventDefault();
        }
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        if(!$('.header.container').hasClass('nav-open')) {
            $('body').css('overflow', 'hidden');
            $('.header.container').addClass('nav-open');
        } else {
            $('.header.container').removeClass('nav-open');
            $('.navbar>.close-menu>.close-button').trigger('click');
        }
    });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('body').css('overflow', 'auto');
    });

}

module.exports = {
    base: mobileMenu
};